import { Link } from 'react-router-dom';

const formats = [
  { icon: 'ri-group-line', title: 'Корпоративный тренинг', desc: 'Очное обучение команды в офисе компании или на внешней площадке. Интенсивный формат с максимальной практикой.' },
  { icon: 'ri-stack-line', title: 'Серия модулей', desc: 'Программа разбита на несколько модулей с промежуточной практикой и домашними заданиями. Оптимально для устойчивых изменений.' },
  { icon: 'ri-compasses-2-line', title: 'Стратегическая сессия', desc: 'Глубинная проработка стратегии продаж и переговоров с командой топ-менеджеров.' },
  { icon: 'ri-gamepad-line', title: 'Бизнес-игры', desc: 'Игровые форматы для отработки переговорных стратегий и принятия решений в условиях конкуренции.' },
  { icon: 'ri-road-map-line', title: 'Полевое сопровождение', desc: 'Совместные звонки, переговоры и встречи — работа «в поле» с последующим разбором.' },
  { icon: 'ri-global-line', title: 'Онлайн', desc: 'Интерактивные вебинары и воркшопы для распределённых команд с сохранением качества обучения.' },
  { icon: 'ri-user-star-line', title: 'Индивидуальный коучинг', desc: 'Персональное развитие руководителя или ключевого менеджера по индивидуальному плану.' },
  { icon: 'ri-refresh-line', title: 'Смешанный формат', desc: 'Blended learning: очные модули + онлайн-поддержка + самостоятельная практика. Максимальная гибкость.' },
];

export default function TrainingFormats() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Форматы обучения
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">
          Выберите оптимальный формат для вашей компании — от однодневного интенсива до <Link to="/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya" className="text-teal-600 hover:text-teal-700 underline">корпоративной академии</Link>
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {formats.map((fmt, i) => (
            <div key={i} className="bg-white rounded-xl p-5 hover:bg-teal-50 hover:ring-2 hover:ring-teal-200 transition-all group border border-gray-100">
              <div className="w-11 h-11 bg-teal-600 rounded-xl flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                <i className={`${fmt.icon} text-lg text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2 group-hover:text-teal-700 transition-colors">
                {fmt.title}
              </h3>
              <p className="text-gray-600 text-xs leading-relaxed">{fmt.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}